import { MsalAuthenticationResult } from '@azure/msal-react'
import { useTranslation } from 'react-i18next'

export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => {
    const { t } = useTranslation()
    return (
        <>
            {t('global.error.anErrorOccured')}: {error ? error.errorCode : t('global.error.unknownError')}
        </>
    )
}
